import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { authenticationActions } from '../../actions';

class Logout extends Component {
    componentDidMount() {
        this.props.logout();
    }

    render() {
        return (
            <Redirect to='/login' />
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(authenticationActions.logout())
    };
};

export default connect(null, mapDispatchToProps)(Logout);
